require('../../components');
require("../components/select-city")
/*
    Показываем/скрываем инфополосу
 */
eventClick('.top-warning-block, .content_block', function () {
    $('.content_block').slideToggle(300);
    $('.read-msg').toggleClass('flip');
});


// Гамбургер
const hamburger = document.querySelector('.c-hamburger');

if (hamburger) {
	hamburger.addEventListener( "click", function(e) {
		e.preventDefault();

		if (e.target.classList.contains("is-active") === true) {
            document.body.classList.remove('menu-open')
            e.target.classList.remove("is-active");
		}

		else {
			e.target.classList.add("is-active");
			document.body.classList.add('menu-open')
		}
	});
}


/*
    Переключение баннера
 */
$('.promo__form').on('submit', function(event) {
    event.preventDefault();
    $('.section.promo').fadeOut(500, function() {
        $('.section.promo-subscription').fadeIn(500);
    });
});


/*
    Просмотр уведомлений
*/
eventClick('.notification .toggle', function () {
    $('.notification .notification-content').toggleClass('visible');
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.notification').length) {
        $('.notification .notification-content').removeClass('visible');
    }
});